import { Link } from "react-router-dom";
import { ArrowRight, Users } from "lucide-react";

const CircleCard = ({ circle, testId }) => (
  <article
    data-testid={testId}
    className="cozy-card rounded-3xl p-8 h-full flex flex-col"
    style={{ background: "var(--surface)" }}
  >
    <div className="flex items-start justify-between gap-3 mb-5">
      <span
        className="px-3 py-1 rounded-full text-[11px] font-semibold tracking-wider uppercase shrink-0"
        style={{
          background: "var(--brand-tint)",
          color: "var(--brand)",
          border: "1px solid var(--border)",
        }}
      >
        {circle.tag}
      </span>
      <span
        className="inline-flex items-center gap-1.5 text-xs shrink-0"
        style={{ color: "var(--text-muted)" }}
      >
        <Users className="w-3.5 h-3.5" />
        {circle.members}
      </span>
    </div>

    <h3
      className="font-serif text-2xl font-medium mb-2"
      style={{ color: "var(--text)" }}
    >
      {circle.name}
    </h3>
    <p
      className="text-sm italic mb-3"
      style={{ color: "var(--text-muted)" }}
    >
      {circle.theme}
    </p>
    <p
      className="text-sm leading-relaxed flex-1"
      style={{ color: "var(--text-soft)" }}
    >
      {circle.desc}
    </p>
    {circle.longDesc && (
      <p
        className="mt-3 text-sm leading-relaxed hidden lg:block"
        style={{ color: "var(--text-muted)" }}
      >
        {circle.longDesc}
      </p>
    )}

    <div className="mt-4 flex flex-wrap gap-2">
      {circle.tags.map((tag) => (
        <span
          key={tag}
          className="text-[10px] px-2.5 py-1 rounded-full uppercase tracking-wider font-medium"
          style={{ background: "var(--bg-alt)", color: "var(--text-muted)" }}
        >
          {tag}
        </span>
      ))}
    </div>

    <p
      className="mt-4 text-xs"
      style={{ color: "var(--text-muted)" }}
    >
      {circle.cadence}
    </p>

    <div
      className="mt-6 pt-5 border-t flex flex-col sm:flex-row gap-2"
      style={{ borderColor: "var(--border-soft)" }}
    >
      <a
        href="https://club.pagepeers.com/register"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-full text-xs font-medium flex-1"
        style={{ background: "var(--brand)", color: "var(--on-brand)" }}
      >
        Join circle
      </a>
      {circle.shelfSlug && (
        <Link
          to={`/shelf/${circle.shelfSlug}`}
          className="inline-flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-full text-xs border flex-1"
          style={{
            borderColor: "var(--border)",
            color: "var(--text)",
            background: "var(--bg-alt)",
          }}
        >
          Related shelf
          <ArrowRight className="w-3.5 h-3.5" />
        </Link>
      )}
    </div>
  </article>
);

export default CircleCard;
